import React from 'react';

import Spinner from '../../Spinner/Spinner';

interface Props {
    name?: string;
    children: React.ReactNode;
    type?: 'submit' | 'reset' | 'button';
    primary: boolean;
    disabled: boolean;
    onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
    icon: React.ReactElement | null;
    iconOnTheLeft?: boolean;
    className?: string;
    hidden?: boolean;
    form?: string;
    value?: any;
    dataSpacePreserve?: string;
}

export default class Button extends React.Component<Props> {
    public static defaultProps = {
        primary: false,
        disabled: false,
        type: 'submit',
        icon: (
            <svg className="icon icon--arrow">
                <use xlinkHref="#icon-arrow" />
            </svg>
        ),
        iconOnTheLeft: false,
        hidden: false,
    };

    private iconSpinner = (<Spinner highPerformance={false} />);

    public render() {
        if (this.props.hidden === true) {
            return null;
        }

        const buttonClass = ['button', this.props.primary ? 'button--primary' : 'button--secondary'];
        if (this.props.icon && !this.props.iconOnTheLeft) {
            buttonClass.push('button--icon-right');
        }
        if (this.props.className) {
            buttonClass.push(this.props.className);
        }

        const icon = this.props.disabled ? this.iconSpinner : this.props.icon;

        return (
            <button
                type={this.props.type}
                onClick={this.props.onClick}
                disabled={this.props.disabled}
                name={this.props.name}
                className={buttonClass.join(' ')}
                form={this.props.form}
                value={this.props.value}
                data-space-preserve={this.props.dataSpacePreserve}
            >
                {this.props.iconOnTheLeft ? icon : null}
                {this.props.children}
                {this.props.iconOnTheLeft ? null : icon}
            </button>
        );
    }
}
